<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-homework-status'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-homework-status"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(abbreviation)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(description)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(viatic_cost)="data">
            <span :class="data.value > 0 ? 'text-success' : 'text-danger'">
              S/,{{ data.value | currency }}
            </span>
          </template>
          <template #cell(viatic_status)="data">
            <b-badge
              pill
              :variant="
                data.value == 'Apply' ? 'light-success' : 'light-warning'
              "
              class="text-capitalize"
            >
              <span> {{ data.value | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(payroll_apply)="data">
            <b-badge
              pill
              :variant="data.value == 'yes' ? 'light-success' : 'light-danger'"
              class="text-capitalize"
            >
              <span> {{ data.value | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(tracking)="data">
            <feather-icon
              @click="openTracking(data.item)"
              icon="AlignJustifyIcon"
              size="17"
              class="cursor-pointer ml-1 text-success"
              v-b-tooltip.hover.left="$t('TRACKING')"
            />
          </template>
          <template #cell(actions)="data">
            <div v-if="!idsProhibidosDeModificar.includes(data.item.id)">
              <feather-icon
                @click="changeStatus(data.item)"
                :icon="typeTab == 1 ? 'ThumbsDownIcon' : 'ThumbsUpIcon'"
                size="17"
                class="cursor-pointer"
                :class="typeTab == 1 ? 'text-danger' : 'text-success'"
                v-b-tooltip.hover.left="
                  $t(typeTab == 1 ? 'DEACTIVATE' : 'ACTIVATE')
                "
              />
              <feather-icon
                v-if="typeTab == 1"
                @click="editStatus(data.item)"
                icon="EditIcon"
                size="17"
                class="cursor-pointer text-warning ml-1"
                v-b-tooltip.hover.left="$t('EDIT')"
              />
            </div>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <ModalHomeworkStatus
      v-if="dataType.status"
      @hideModal="dataType.status = false"
      :dataType="dataType"
      @refresh="
        $refs['ref-table-homework-status'].refresh();
        dataType.status = false;
      "
    />
    <ModalTrackingHomeworkStatus
      v-if="statusTracking"
      @hideModal="statusTracking = false"
      :dataType="dataType"
    />
  </div>
</template>
<script>
/* STORE */
import { mapGetters } from "vuex";
/* SERVICES */
import HomeworkStatusService from "@/views/settings/views/homework-status/service/homework-status.service.js";
/* DATA */
import fields from "@/views/settings/views/homework-status/data/Fields.data";
/* COMPONENTS */
import ModalHomeworkStatus from "@/views/settings/views/homework-status/components/modals/ModalHomeworkStatus.vue";
import ModalTrackingHomeworkStatus from "@/views/settings/views/homework-status/components/modals/ModalTrackingHomeworkStatus.vue";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

export default {
  components: {
    FilterSlot,
    ModalHomeworkStatus,
    ModalTrackingHomeworkStatus,
  },
  data() {
    return {
      filters: [],
      isBusy: false,
      searchQuery: "",
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      dataType: {
        status: false,
        type: "edit",
        data: [],
      },
      statusTracking: false,
      idsProhibidosDeModificar: [
        3, // FA - Falta
        7, // VA - Vacaciones
        8, // TA - Tardanza
        26, // VAC - Vacaciones compradas
      ],
    };
  },
  computed: {
    typeTab() {
      return this.$route.meta.tab;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    fields() {
      return fields.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
    },
  },
  created() {},
  methods: {
    async myProvider(ctx) {
      try {
        this.addPreloader();
        let params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search: this.filterPrincipal.model,
          orderby: 1,
          order: "desc",
          typeTab: this.typeTab,
          viaticStatus: null,
          abreviation: null,
        };
        const { data } = await HomeworkStatusService.getHomeworkStatuses(
          params
        );
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    editStatus(data) {
      this.dataType.data = data;
      this.dataType.status = true;
    },
    async changeStatus(data) {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          await this.addPreloader();
          let params = {
            status: data.status === 1 ? 2 : 1, //  1 (Active) - 2 (Inactive)
            abbreviation: data.abbreviation,
            description: data.description,
            viatic_status: data.viatic_status,
            viatic_cost: data.viatic_cost,
            created_by: this.currentUser.id,
            id: data.id,
          };
          await HomeworkStatusService.updateHomeworkStatus(params);
          this.$refs["ref-table-homework-status"].refresh();
        }
      } catch (error) {
        console.log(error);
      } finally {
        await this.removePreloader();
      }
    },
    openTracking(data) {
      this.dataType.data = data;
      this.statusTracking = true;
    },
    refreshTable() {
      this.$refs["ref-table-homework-status"].refresh();
    },
  },
};
</script>
